export default {
  computed: {
    discussions() {
      if (!this.flashcard?.id || this.flashcard.userOwned) return [];
      return this.$store.getters['discussions/getDiscussionsByFlashcardId'](this.flashcard.id);
    },
    discussionPostCount() {
      return this.discussions?.length || 0;
    },
  },
  watch: {
    flashcard() {
      this.fetchDiscussions();
    },
  },
  created() {
    this.fetchDiscussions();
  },
  methods: {
    fetchDiscussions() {
      const params = {
        flashcardId: this.flashcard.id,
      };

      if (!this.flashcard?.id || this.flashcard.userOwned) return;
      this.$store.dispatch('discussions/fetchDiscussions', params);
    },
  },

};
